import { Subject } from 'rxjs/Subject';

import { Option as CharacteristicOption } from '@components/ProductCharacteristicsFilter';

export enum EventStreamEvents {
  filter = 'filter',
  brandInputChange = 'brandInputChange',
  brandInputChanged = 'brandInputChanged',
  brandsSuggestReceived = 'brandsSuggestReceived',
  cityChangeClicked = 'cityChangeClicked',
  cityFormSubmit = 'cityFormSubmit',
  closeClicked = 'closeClicked',
  setPriceFilter = 'setPriceFilter',
  setCustomPriceFilter = 'setCustomPriceFilter',
  setCityFilter = 'setCityFilter',
  setSizeFilter = 'setSizeFilter',
  setColorFilter = 'setColorFilter',
  setMadeInUkraineFilter = 'setMadeInUkraineFilter',
  setConditionFilter = 'setConditionFilter',
  brandChanged = 'brandChanged',
  setFreeShipping = 'setFreeShipping',
  setIsOnSale = 'setIsOnSale',
  characteristicChanged = 'characteristicChanged',
  sortDirectionChanged = 'sortDirectionChanged',
  setPage = 'setPage',
  excludeFilterValue = 'excludeFilterValue',
  clearFilterValue = 'clearFilterValue',
  clearAllFilters = 'clearAllFilters',
}

export type EventStream = Subject<{
  action: EventStreamEvents;
  characteristic?: CharacteristicOption,
  ukrainian?: number | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}>;
